<template>
    <div class="invoices" uk-height-viewport>
        <Header/>
        <div uk-grid class="uk-margin uk-margin-remove-right">
            <div class="uk-width-auto">
                <legend class="uk-legend uk-margin-left uk-text-left uk-text-bold">Factures</legend>
            </div>
            <div class="uk-width-auto">
                <div class="uk-margin uk-margin-remove-bottom">
                    <div uk-form-custom="target: > * > span:first-child">
                        <select v-model="selectedMonth">
                            <option value="all">Toutes</option>
                            <option
                                v-for="(monthDate, index) in monthsSinceRelease"
                                :key="index"
                                :value="monthDate"
                            >{{ monthDate.toHumanReadableFormat() }}
                            </option>
                        </select>
                        <button
                            class="uk-button uk-button-default uk-border-rounded"
                            type="button"
                            tabindex="-1"
                        >
                            <span></span>
                            <span uk-icon="icon: chevron-down"></span>
                        </button>
                    </div>
                </div>
                <p class="uk-text-small uk-text-muted uk-text-middle uk-margin-remove-top">Chiffre d'affaire :
                    {{ getRevenue() }}€</p>
            </div>
            <div class="uk-width-expand">
                <form class="uk-search uk-search-default uk-width-1-1">
                    <input
                        class="uk-search-input"
                        type="search"
                        placeholder="Rechercher"
                        v-model="searchText"
                        @input="filterInvoices"
                        aria-label="Search"
                    />
                    <button class="uk-search-icon-flip" uk-search-icon></button>
                </form>
            </div>
            <div class="uk-width-expand">
                <div class="uk-align-right uk-margin-right">
                    <div
                        v-show="!isLoading && filteredInvoices.length !== 0"
                        class="uk-grid-small uk-child-width-auto uk-flex uk-flex-right"
                    >
                        <button
                            class="uk-button uk-button-default uk-button-right uk-border-rounded uk-text-bold uk-margin-bottom"
                            v-on:click="generateSheetFile()"
                        >
                            <span class="uk-icon uk-margin-small-right" uk-icon="icon: file-text"></span>Générer le
                            rapport comptable
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="uk-flex uk-flex-center">
            <p
                class="uk-margin-large-top uk-text-bolder"
                v-show="filteredInvoices.length === 0"
            >Aucune facture disponible</p>
            <table
                class="uk-table uk-table-small uk-table-divider uk-table-hover uk-table-justify"
                v-show="filteredInvoices.length > 0"
                id="invoicesTable"
            >
                <thead>
                <tr>
                    <th class="uk-text-center">
                        <p class="uk-text-bold">Date</p>
                    </th>
                    <th class="uk-text-center">
                        <p class="uk-text-bold">Nº</p>
                    </th>
                    <th class="uk-text-center">
                        <p class="uk-text-bold">Identité</p>
                    </th>
                    <th class="uk-text-center">
                        <p class="uk-text-bold">Montant HT</p>
                    </th>
                    <th class="uk-text-center">
                        <p class="uk-text-bold">Montant TTC</p>
                    </th>
                    <th class="uk-text-center">
                        <p class="uk-text-bold">Montant TVA</p>
                    </th>
                    <th class="uk-text-center">
                        <p class="uk-text-bold">Action</p>
                    </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(invoice, index) in filteredInvoices" :key="index" @click="edit(invoice)">
                    <td class="uk-text-middle">{{ toNumericReadableFormat(invoice.createdAt.toDate()) }}</td>
                    <td class="uk-text-middle">#{{ invoice.invoiceID }}</td>
                    <td class="uk-text-middle">{{ invoice.firstName }} {{ invoice.lastName }}</td>

                    <td class="uk-text-middle">{{ (invoice.amount / 1.2).toFixed(2) }}€</td>

                    <td class="uk-text-middle">{{ invoice.amount.toFixed(2) }}€</td>

                    <td class="uk-text-middle">{{ (invoice.amount - invoice.amount / 1.2).toFixed(2) }}€</td>

                    <td class="uk-text-middle">
              <span
                  class="uk-form-default uk-margin-right"
                  style="cursor:pointer;"
                  uk-icon="file-pdf"
                  uk-tooltip="title: Consulter; delay: 500"
                  v-on:click="consult(invoice)"
              ></span>
                    </td>
                    <td class="uk-text-middle">
                  <span
                      class="uk-form-default uk-margin-right"
                      :style="{ color: getInfoDocument(invoice), cursor: 'pointer' }"
                      uk-icon="file-text"
                      uk-tooltip="title: Consulter; delay: 500"
                  ></span>
                        <span
                            class="uk-form-default uk-margin-right"
                            :style="{ color: getInfoSms(invoice), cursor: 'pointer' }"
                            uk-icon="mail"
                            uk-tooltip="title: Consulter; delay: 500"
                        ></span>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import UIkit from "uikit";
import InvoiceStatus from "../enums/invoice-status";
import Invoice from "../models/invoice";
import Header from "../components/Header";
import firebase from "firebase";
import XLSX from "xlsx";
import moment from "moment";
import IconColor from "@/enums/icon-color";
import DocumentStatus from "@/enums/document-status";

export default {
    name: "invoice",
    computed: {
        IconColor() {
            return IconColor
        }
    },
    components: {
        Header
    },
    data() {
        return {
            selectedMonth: "all",
            monthsSinceRelease: [],
            invoices: [],
            filteredInvoices: [],
            isLoading: true,
            searchText: "",
            dataStatuses: [],
            messages: [],
            messagesExpert: []
        };
    },

    watch: {
        selectedMonth: function (newSelectedMonth) {
            this.fetchInvoices(newSelectedMonth);
        }
    },

    async mounted() {
        await this.fetchInvoices(this.selectedMonth);
        this.experts = await firebase.firestore().collection("Users").where("isExpert", "==", true).get().then((querySnapshot) => {
            if (querySnapshot.empty) {
                return [];
            }
            return querySnapshot.docs.map(doc => {
                return {
                    uid: doc.id,
                    ...doc.data()
                };
            });
        });
        this.getMonthsSinceRelease();
    },

    methods: {
        async fetchInvoices(selectedMonth) {
            this.isLoading = true;
            let query = firebase.firestore().collection("Invoices").orderBy("createdAt", "desc");
            if (selectedMonth !== "all") {
                const start = new Date(selectedMonth);
                start.setHours(0, 0, 0, 0);
                const end = new Date(start);
                end.setMonth(end.getMonth() + 1);
                query = query.where("createdAt", ">=", start).where("createdAt", "<", end);
            } else {
                const rawLimit = parseInt(this.$route.params.limit);
                const limit = isNaN(rawLimit) || rawLimit <= 0 ? 100 : rawLimit;
                query = query.limit(limit);
            }
            const querySnapshot = await query.get();
            this.invoices = [];
            querySnapshot.forEach(doc => {
                this.invoices.push(new Invoice(doc));
            });
            this.filteredInvoices = this.invoices;
            this.isLoading = false;
        },

        filterInvoices() {
            if (!this.searchText) {
                this.filteredInvoices = this.invoices;
            } else {
                this.filteredInvoices = this.invoices.filter(invoice => {
                    const searchTerm = this.searchText.toLowerCase();
                    return (
                        invoice.firstName.toLowerCase().includes(searchTerm) ||
                        invoice.lastName.toLowerCase().includes(searchTerm) ||
                        invoice.invoiceID.toString().includes(searchTerm) ||
                        invoice.amount.toFixed(2).includes(searchTerm)
                    );
                });
            }
        },

        getRevenue() {
            var amount = 0
            for (var i = 0; i < this.filteredInvoices.length; i++) {
                amount += this.filteredInvoices[i].amount
            }
            return amount
        },

        getMonthsSinceRelease() {
            var monthsSinceRelease = [];
            var releaseDate = new Date();
            releaseDate.setFullYear(2019, 10, 1);
            releaseDate.setHours(0, 0, 0, 0);
            monthsSinceRelease.push(releaseDate);
            var releaseDateMoment = new moment(releaseDate);

            var now = new moment(new Date());

            var duration = moment.duration(now.diff(releaseDateMoment));
            var monthsCount = duration.asMonths();
            while (monthsCount > 1) {
                monthsSinceRelease.push(releaseDateMoment.add(1, "months").toDate());
                monthsCount--;
            }

            this.monthsSinceRelease = monthsSinceRelease;
        },

        getStatusTitle: function (invoice) {
            switch (invoice.status) {
                case InvoiceStatus.INVOICED:
                    return "Facturé";
            }
            return "Non déterminé";
        },

        deleteInvoice: function (index) {
            if (
                confirm(
                    "Êtes vous sûr(e) de vouloir supprimer cette facture ? Cela peut causer une erreur de numérotation dans la facturation."
                )
            ) {
                const self = this;
                const invoice = this.invoices[index];
                firebase
                    .firestore()
                    .collection("Invoices")
                    .doc(invoice.uid)
                    .delete()
                    .then(() => {
                        self.invoices.splice(index, 1);
                        self.displayMessage("Facture supprimée avec succès.");
                    })
                    .catch(function (error) {
                        console.log("Error removing documents: ", error);
                    });
            }
        },

        toNumericReadableFormat: function (date) {
            var day = date.getDate();
            var monthIndex = date.getMonth() + 1;
            var year = date.getFullYear();
            return "" + day + "/" + monthIndex + "/" + year;
        },

        displayMessage: function (message) {
            UIkit.notification("<span uk-icon='check: warning'></span> " + message, {
                pos: "top-right",
                status: "success"
            });
        },

        consult: function (document) {
            const storage = firebase.storage().ref();
            var path = document.firebaseStoragePath();

            storage
                .child(path)
                .getDownloadURL()
                .then(function (url) {
                    window.open(url, "_blank", "fullscreen=yes");
                })
                .catch(function (error) {
                    console.log(error);
                });
        },

        edit: function (invoice) {
            this.$router.push({name: "InvoiceDetails", params: {invoice: invoice}});
        },

        generateSheetFile() {
            var tbl = document.getElementById("invoicesTable");
            var wb = XLSX.utils.table_to_book(tbl);
            if (!wb.Props) wb.Props = {};
            var now = new Date();
            var monthTitle = this.selectedMonth === 'all' ? "Novembre 2019 à " + (new Date()).toHumanReadableFormat() : this.selectedMonth.toHumanReadableFormat()
            const title =
                "Relevé facturation - Check my House - " + monthTitle
            wb.Props.Title = title;
            wb.Props.Author = "Check my House";
            wb.Props.Company = "Check my House";
            wb.Props.CreatedDate = now;
            var sheet = wb.Sheets[wb.SheetNames[0]];
            sheet["G1"] = {hidden: true};
            XLSX.writeFile(wb, title + ".xls");
        },

        getInfoDocument(invoice) {
            if(undefined === invoice.documents || invoice.documents.length === 0) {
                return IconColor["0"];
            }
            let count = invoice.documents.filter(document => document.status === DocumentStatus.SIGNED).length;
            if (count >= 2) {
                return IconColor["2"];
            }
            return IconColor["1"];
        },

        getInfoSms(invoice) {
            if(undefined === invoice.sms_ids || invoice.sms_ids.length === 0) {
                return IconColor["0"];
            }
            if (invoice.sms_ids.length >= 2) {
                return IconColor["2"];
            }
            return IconColor["1"];
        },
    }
};

Date.prototype.toHumanReadableFormat = function () {
    var monthNames = [
        "Janvier",
        "Février",
        "Mars",
        "Avril",
        "Mai",
        "Juin",
        "Juillet",
        "Aout",
        "Septembre",
        "Octobre",
        "Novembre",
        "Décembre"
    ];

    var monthIndex = this.getMonth();
    var year = this.getFullYear();

    return monthNames[monthIndex] + " " + year;
};
</script>

<style scoped>
table tbody tr:hover {
    background-color: rgba(48, 158, 181, 0.05);
}
</style>